export default {
  palette: {
    primary: {
      main: '#92b604',
    },
  },
};
